import React, { Component } from 'react';
import { BeatLoader } from 'react-spinners';
import Modal from 'react-modal';
import Select from 'react-select';
import NotificationSystem from 'react-notification-system';
import { _addNotification, _addNotificationError, getSchoolGrades } from "./../../../../server/util";
import { withRouter } from "react-router-dom";
import RichText from './../../../Misc/RichText';
import { EditorState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import { get, postWithHeaders } from './../../../../server/actions';
import { getActiveStudentsBySchoolYear } from './../../Home/dashboardItemsService'

const normalizeSmartPunctuation = (text = '') => {
    if (typeof text !== 'string') return text;
    const replacements = {
        '\u2018': '&#8216;',
        '\u2019': '&#8217;',
        '\u201C': '&#8220;',
        '\u201D': '&#8221;',
        '\u2013': '&#8211;',
        '\u2014': '&#8212;'
    };
    return text.replace(/[\u2018\u2019\u201C\u201D\u2013\u2014]/g, (match) => replacements[match] || match);
};

// Module filters available for narrowing a broadcast down to schools that have
// the corresponding moduleAccess flag(s) enabled on /mealSchools/{mealSchoolId}.
// `code` is what gets posted to the API; `moduleNames` are the moduleAccess keys
// the code maps to (a filter matches when ANY of its moduleNames is enabled).
const MODULE_FILTERS = [
    {
        code: 'ORDER_MANAGEMENT_ANY',
        label: 'Order Management (any)',
        moduleNames: ['Lunch Order Management', 'Breakfast Order Management', 'Snack Order Management', 'Dinner Order Management']
    },
    { code: 'INSTANT_PAYMENT_FOR_ORDERS', label: 'Instant Payment for Orders', moduleNames: ['Instant Payment for Orders'] },
    { code: 'ADD_PAYMENT_ONLINE', label: 'Add Payment - Online', moduleNames: ['Add Payment - Online'] },
    { code: 'LUNCH_ELIGIBILITY_TYPE_MANAGEMENT', label: 'Lunch Eligibility type management', moduleNames: ['Lunch Eligibility type management'] },
    { code: 'CEP_SCHOOL', label: 'CEP School', moduleNames: ['CEP School'] },
    { code: 'ONLINE_LUNCH_ELIGIBILITY_APPLICATION', label: 'Online Lunch Eligibility Application', moduleNames: ['Online Lunch Eligibility Application'] },
    { code: 'NUTRITION_ANALYSIS', label: 'Nutrition Analysis', moduleNames: ['Nutrition Analysis'] },
    { code: 'INVENTORY_RECORD', label: 'Inventory Record', moduleNames: ['Inventory Record'] },
    { code: 'PRODUCTION_RECORD', label: 'Production Record', moduleNames: ['Production Record'] },
    { code: 'POS_DEPOSITS', label: 'POS Deposits', moduleNames: ['POS Deposits'] }
];

const isModuleEnabled = (moduleAccess, moduleName) => {
    const value = (moduleAccess || {})[moduleName];
    if (value === true) return true;
    return typeof value === 'string' && value.trim().toLowerCase() === 'yes';
};

// Mirrors the server side filter so the super admin can see how many schools a
// selection will reach before sending. Advisory only - the API is authoritative.
const schoolMatchesFilters = (school, selectedModules, matchMode) => {
    if ((selectedModules || []).length === 0) return true;
    let moduleAccess = (school || {}).moduleAccess || {};
    if (typeof moduleAccess === 'string') {
        try { moduleAccess = JSON.parse(moduleAccess); } catch (ex) { moduleAccess = {}; }
    }
    const results = selectedModules.map(code => {
        const filter = MODULE_FILTERS.find(f => f.code === code);
        if (!filter) return false;
        return filter.moduleNames.some(name => isModuleEnabled(moduleAccess, name));
    });
    return matchMode === 'ALL' ? results.every(Boolean) : results.some(Boolean);
};

let schoolGrades = [];
class BroadcastMessage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            showTestModalWindow: false,
            testEmailId: '',
            isValidEmail: true,
            error: null,
            reqObj: {
                subject: "",
                message: EditorState.createEmpty(),
                htmlText: '',
                footer: "",
                attachments: [],
            },
            schools: [],
            selectedSchool: '',
            selectedModules: [],
            moduleMatchMode: 'ANY',
            loggedUser: JSON.parse(sessionStorage.getItem('loggedInUserDetails'))
        }
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
        this.getAllSchools();
    }

    getAllSchools = () => {
        this.setState({ loading: true });
        const url = `/mealSchools/search/findByIsActive?isActive=true&page=0&size=2147483647&access_token=`;
        get(url).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            this.setState({ schools: data._embedded.mealSchools || [], loading: false });
        }).catch((error) => {
            this.setState({ schools: [], loading: false })
        });
    }

    handleSubmit(e, type = '') {
        e.preventDefault();
        // let headers = {
        //      "Content-Type": "multipart/form-data",
        //     "Accept": "application/json"
        // }; 



        let user = this.state.loggedUser;
        const { reqObj } = this.state;
        const normalizedHtmlText = normalizeSmartPunctuation(this.state.reqObj.htmlText || '');
        const normalizedSubject = normalizeSmartPunctuation(this.state.reqObj.subject || '');
        const normalizedFooter = normalizeSmartPunctuation(this.state.reqObj.footer || '');

        if (type == 'TEST') {
            if (this.state.testEmailId == '') {
                _addNotificationError('Please provide email id for send test message', this);
                return false;
            }

        } else {
            if ((this.state.selectedSchool || '') == '') {
                _addNotificationError('Please select school', this);
                return false;
            }
        }

        let data = {
            "mealSchoolIds": (this.state.selectedSchool || '') == '' ? undefined : this.state.selectedSchool == -1 ? this.state.schools.map(s => {
                const id = s._links.self.href.split('/').pop();
                return id;
            }) : [this.state.selectedSchool],
            "subject": normalizedSubject,
            "message": normalizedHtmlText,
            "footer": normalizedFooter,
            "email": this.state.testEmailId,
        }

        // Module filters only narrow a real broadcast - a test mail always goes
        // to the single address that was entered.
        if (type != 'TEST' && (this.state.selectedModules || []).length > 0) {
            data.moduleFilters = this.state.selectedModules;
            data.moduleFilterMatch = this.state.moduleMatchMode;
        }

        if (normalizedSubject.trim() === '') {
            _addNotificationError('subject is required.', this);
            return false;
        }

        let headers = {
            "Content-Type": "multipart/form-data",
        };
        let formData = new FormData();
        formData.append('body', JSON.stringify(data));
        (this.state.reqObj.attachments || []).map(file => {
            formData.append('files', file);
        });

        postWithHeaders(`/custom/notification/admins?access_token=`, formData, undefined).then((response) => {
            console.log("Response::::", response);
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.text();
        }).then(data => {
            if (type == 'TEST') {
                this.setState({ loading: false, showTestModalWindow: false, testEmailId: '' });
                _addNotification('Email sent successfully.', this)
            } else {
                const _reqObj = {};
                _reqObj.subject = '';
                _reqObj.message = EditorState.createEmpty();
                _reqObj.htmlText = '';
                _reqObj.attachments = [];
                _reqObj.selectedStudents = [];
                _reqObj.footer = '';
                this.setState({ loading: false, reqObj: { ..._reqObj }, selectedSchool: '', selectedModules: [], moduleMatchMode: 'ANY' });

                _addNotification('Email sent Successfully.', this);
            }

        }).catch(
            (error) => {
                this.setState({ loading: false });
                _addNotificationError('Please try again!', this);
            }
        )
        return false;
    }

    cancelRequestForm = () => {
        const _reqObj = {};
        _reqObj.subject = '';
        _reqObj.message = EditorState.createEmpty();
        _reqObj.htmlText = '';
        _reqObj.footer = '';
        this.setState({ loading: false, reqObj: { ..._reqObj }, selectedModules: [], moduleMatchMode: 'ANY' });
        this.gradeCheck();
        document.getElementById("select_all").checked = false;
        this.props.history.push('/schoolAdmin')
    }

    sendTestMail = (e) => {
        if ((this.state.testEmailId || '').trim() == '') {
            _addNotificationError('Please enter your Email Id.', this);
        } else {
            this.handleSubmit(e, 'TEST');
        }
    }
    isValidEmail = (email) => {
        return /\S+@\S+\.\S+/.test(email);
    }

    handleChange = (event) => {
        if (!this.isValidEmail(event.target.value)) {
            this.setState({ error: 'Email is invalid' });
        } else {
            this.setState({ error: null });
        }

        this.setState({ testEmailId: event.target.value });
    };

    toggleModuleFilter = (code) => {
        const selectedModules = [...(this.state.selectedModules || [])];
        const index = selectedModules.indexOf(code);
        if (index > -1) {
            selectedModules.splice(index, 1);
        } else {
            selectedModules.push(code);
        }
        this.setState({ selectedModules });
    }

    // Schools the broadcast targets before module filtering is applied.
    getTargetedSchools = () => {
        const { schools, selectedSchool } = this.state;
        if ((selectedSchool || '') == '') return [];
        if (selectedSchool == -1) return schools;
        return schools.filter(sch => sch._links.self.href.split('/').pop() == selectedSchool);
    }

    renderModuleFilters = () => {
        const { selectedModules, moduleMatchMode } = this.state;
        const targeted = this.getTargetedSchools();
        // moduleAccess is not guaranteed to be on the school search payload - only
        // show the preview when we actually have data to evaluate.
        const hasModuleData = targeted.some(sch => (sch || {}).moduleAccess);
        const matching = targeted.filter(sch => schoolMatchesFilters(sch, selectedModules, moduleMatchMode));

        return <div className='form-group'>
            <label>Filter by Module Access: </label>
            <span style={{ fontWeight: 'normal', marginLeft: '8px', color: '#777' }}>
                (optional - leave all unchecked to send to every selected school)
            </span>
            <div style={{ border: '1px solid #ddd', borderRadius: '4px', padding: '10px', marginTop: '5px' }}>
                <div className='row'>
                    {
                        MODULE_FILTERS.map((filter, i) => {
                            return <div className='col-md-6' key={filter.code}>
                                <div className='checkbox' style={{ marginTop: '3px', marginBottom: '3px' }}>
                                    <label>
                                        <input type='checkbox'
                                            checked={(selectedModules || []).indexOf(filter.code) > -1}
                                            onChange={() => this.toggleModuleFilter(filter.code)} />
                                        {filter.label}
                                    </label>
                                </div>
                            </div>
                        })
                    }
                </div>
                {
                    (selectedModules || []).length > 1 &&
                    <div style={{ borderTop: '1px solid #eee', marginTop: '8px', paddingTop: '8px' }}>
                        <label style={{ fontWeight: 'normal', marginRight: '15px' }}>
                            <input type='radio' name='moduleMatchMode' style={{ marginRight: '4px' }}
                                checked={moduleMatchMode === 'ANY'}
                                onChange={() => this.setState({ moduleMatchMode: 'ANY' })} />
                            Match any selected module
                        </label>
                        <label style={{ fontWeight: 'normal' }}>
                            <input type='radio' name='moduleMatchMode' style={{ marginRight: '4px' }}
                                checked={moduleMatchMode === 'ALL'}
                                onChange={() => this.setState({ moduleMatchMode: 'ALL' })} />
                            Match all selected modules
                        </label>
                    </div>
                }
                {
                    (selectedModules || []).length > 0 && targeted.length > 0 && hasModuleData &&
                    <div style={{ marginTop: '8px', color: matching.length === 0 ? '#a94442' : '#3c763d' }}>
                        <i className='fa fa-info-circle'></i>&nbsp;
                        {matching.length} of {targeted.length} selected school(s) match this filter.
                    </div>
                }
            </div>
        </div>
    }

    renderTestMailModal = () => {
        const alertStyle = {
            content: {
                top: '40%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                width: '40%',
                transform: 'translate(-50%, -50%)',
                overflow: 'initial',
                WebkitBoxShadow: '0 5px 11px 0 rgba(0,0,0,0.18), 0 4px 15px 0 rgba(0,0,0,0.15)',
                boxShadow: '0 5px 11px 0 rgba(0,0,0,0.18), 0 4px 15px 0 rgba(0,0,0,0.15)'
            }
        }
        return <Modal isOpen={this.state.showTestModalWindow} style={alertStyle} >
            <div className="modal-header row">
                <h4 className="modal-title modal-title-color col-md-6" id="refundLabel">Test Email</h4>
                <div className="col-md-6"><button type="button" className="pull-right btn-danger"
                    onClick={() => { this.setState({ showTestModalWindow: false }) }}>X</button></div>
            </div>
            <div className="modal-body">
                <div className='row'>
                    <div className='col-md-12'>
                        <div className="form-group">
                            <label>Enter email id for test mail:</label>
                            <input type="email" className='form-control' onChange={(e) => this.handleChange(e)} />
                            {this.state.error && <div style={{ color: 'red' }}>{this.state.error}</div>}
                        </div>
                    </div>
                </div>
            </div>
            <div className="text-right">
                <button type="button" className="btn btn-danger btn-xs"
                    onClick={() => {
                        this.setState({ showTestModalWindow: false, testEmailId: '' });
                    }}><i className="fa fa-check-circle" style={{ margin: '0 0 0 5px' }} ></i> Cancel
                </button>&nbsp;
                <button type="button" className="btn btn-success btn-xs" disabled={(this.state.error) ? true : false}
                    onClick={(e) => {
                        this.sendTestMail(e);
                    }}><i className="fa fa-check-circle" style={{ margin: '0 0 0 5px' }} ></i> Ok
                </button>
            </div>

        </Modal>
    }

    render() {
        const { reqObj, schools, selectedSchool } = this.state
        return (
            <section className="mainContent full-width clearfix">
                <NotificationSystem ref="notificationSystem" />
                <div className='sweet-loading' style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000' }}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <div>
                    <div className="container" style={{ marginTop: '25px' }}>
                        <div className="col-md-offset-2 col-md-8 col-sm-12">
                            <div className="panel panel-primary" >
                                <div class="panel-heading text-center">
                                    <h3 class="panel-title">Broadcast Message</h3>
                                </div>
                                <div className='panel-body'>

                                    <div className="form-group" >
                                        <label>Subject: </label>
                                        <input type='text' className="form-control" value={this.state.reqObj.subject}
                                            placeholder="subject" spellcheck="false" onChange={(e) => {
                                                this.state.reqObj.subject = e.target.value;
                                                this.setState({ reqObj: { ...this.state.reqObj } });
                                            }}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Message: </label>
                                        <RichText editorState={this.state.reqObj.message} onEditorStateChange={(editorState) => {
                                            this.state.reqObj.message = editorState;
                                            this.state.reqObj.htmlText = normalizeSmartPunctuation(draftToHtml(convertToRaw(this.state.reqObj.message.getCurrentContent())));
                                            this.setState({ reqObj: { ...this.state.reqObj } });
                                        }} />

                                    </div>

                                    <div className='form-group'>
                                        <label>Attachments :</label> <br />
                                        {
                                            (reqObj.attachments || []).map((file, i) => {
                                                return <span className="label label-primary">{file.name} <span style={{ cursor: 'pointer' }} onClick={(e) => {
                                                    const { reqObj } = this.state;
                                                    reqObj.attachments.splice(i, 1);
                                                    this.setState({ reqObj: { ...reqObj } });
                                                }}><i className='fa fa-trash'></i></span></span>
                                            })
                                        }
                                    </div>
                                    <div className='form-group'>
                                        <input type='file' multiple className='form-control' onChange={(e) => {
                                            if (e.target.files.length > 0) {
                                                const { reqObj } = this.state;
                                                let files = e.target.files;
                                                reqObj.attachments = [...reqObj.attachments, ...files];
                                                this.setState({ reqObj: { ...reqObj } });
                                            }
                                            e.target.value = null;
                                        }} />
                                    </div>
                                    <div className="form-group" style={{ float: 'right' }} >
                                        <a href='javascript:void(0)' onClick={(e) => {
                                            this.setState({ showTestModalWindow: true, testEmailId: '' });
                                        }}><i className="fa fa-share-square-o"></i><span>Send Test Mail</span></a>

                                    </div>
                                    <br />
                                    <div className='form-group'>
                                        <label>Select School: </label>
                                        <select className='form-control' value={selectedSchool} onChange={(e) => {
                                            this.setState({ selectedSchool: e.target.value });
                                        }}>
                                            <option></option>
                                            <option value={-1}>All</option>
                                            {
                                                schools.map((sch, i) => {
                                                    const id = sch._links.self.href.split('/').pop();
                                                    return <option key={i + 1} value={id}>{sch.schoolName}</option>
                                                })
                                            }
                                        </select>
                                    </div>
                                    {this.renderModuleFilters()}
                                    <div className="col-md-7 col-md-offset-3 text-center">
                                        <button className="btn btn-danger btn-sm" onClick={() => {
                                            this.cancelRequestForm()
                                        }}
                                            type="submit">Cancel
                                        </button>&nbsp;&nbsp;
                                        <button type="submit" id="submit" onClick={(e) => {
                                            {
                                                this.handleSubmit(e);
                                            }
                                        }} className="btn btn-sm btn-success"><i
                                            className="fa fa-share-square-o"></i><span>Send</span></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    this.renderTestMailModal()
                }
            </section>
        );
    }
}
export default withRouter(BroadcastMessage);


// WEBPACK FOOTER //
// ./src/components/SuperAdmin/Support/broadcastMessage/index.js